// removed by extract-text-webpack-plugin
module.exports = {"container":"_3gBcJHMfXNf6FECJUb_Aqm","fade-in":"_3AmIj6RlQuYyhesoROdFI6"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Contact/styles.css
// module id = 314
// module chunks = 0